import {httpRequest, utimeHttpRequest} from '@/app/http'
import type {PhotoDetailParams, PhotoListParam, PhotoStatus, AlbumAttrProps} from '@/views/props'

//初始化oss云存储
export const getOSSUploadParams = params => utimeHttpRequest('my_utime/oss/init', params, {method: 'GET'})
/**
 * 查询相册列表
 */
export const useGetAlbumList = (params: PhotoListParam) => utimeHttpRequest('my_utime/pl/album/photo/list', params, {method: 'POST'})

/**
 * 获取相册详情
 * @returns AlbumDetailProps
 */
export const useGetAlbumDetail = (params: {albumId: string}) => utimeHttpRequest('my_utime/pl/album', params)

/**
 *  获取相册分类列表
 */
export const useGetAlbumLabelList = (params: {albumId: string; backRetouch: boolean; photoStatus: PhotoStatus}) =>
    utimeHttpRequest('my_utime/pl/album/label', params)

/**
 * 查看照片详情
 */
export const useGetAlbumPhotoDetail = (params: PhotoDetailParams) => utimeHttpRequest('my_utime/pl', params)

/**
 *  获取相册内人脸识别人员列表
 * @returns boolean
 */
export const useGetAIPersonList = (params: {albumId: string; page: number; pageSize?: number}) => utimeHttpRequest('my_utime/pl/album/person', params)

export const useGetWatermark = (params: any) => utimeHttpRequest('my_utime/pl/album/watermark', params)

// 数据统计埋点
export const useDataPoint = (params: any) => utimeHttpRequest('my_utime/data/buried/point', params, {method: 'POST'})

// 获取相册属性
export const useAlbumAttr = (params: AlbumAttrProps) => utimeHttpRequest('my_utime/album/attr', params)

// 修改相册属性(不包含相册品牌卡片)
export const updateAlbumAttr = (params: any) => utimeHttpRequest('my_utime/album/attr', params, {method: 'PUT'})

// h5 微信登录
export const JSSDK = (params: any) => utimeHttpRequest('https://pro.kapaisy.com/my/my_account/user/login/h5/wx', params, {method: 'POST'})

// 点赞
export const usePhotoLike = (params: any) => utimeHttpRequest('my_utime/album/photo/like', params, {method: 'POST'})

// 验证密码
export const useCheckPassword = (params: any) => utimeHttpRequest('my_utime/pl/album/check/password', params, {method: 'POST'})

//点赞和取消点赞
export const likePhoto = params => utimeHttpRequest('my_utime/album/photo/like', params, {method: 'POST'})

// 陌生人上传
export const uploadStranger = params => utimeHttpRequest('my_upload/upload/oss/stranger', params, {method: 'POST'})

//搜索人脸
export const useSearchFace = params => utimeHttpRequest('my_utime/face/search', params, {method: 'POST'})

// 获取相册集详情
export const useGetGather = params => utimeHttpRequest('my_utime/album/gather/detail', params, {method: 'GET'})

// 获取相册集属性
export const useGetGarherAttr = params => utimeHttpRequest('my_utime/album/gather/attr', params, {method: 'GET'})

// 获取相册集相册列表
export const useGetAlbumForGather = params => utimeHttpRequest('my_utime/album/gather/album/list', params, {method: 'GET'})

// 验证相册集密码
export const useCheckGatherPassword = params => utimeHttpRequest('my_utime/album/gather/check', params, {method: 'POST'})

// 获取h5重定向地址
export const getRedirectUrl = () => utimeHttpRequest('my_utime/pl/h5/url', {}, {method: 'GET'})

export const getUploadphotoId = (count: number) => utimeHttpRequest('my_upload/file/fileId/' + count)

export const getUserHome = params => utimeHttpRequest('my_utime/pl/user/home', params, {method: 'GET'})

//获取照片审图信息
export const getPhotoAuditInfo = params => utimeHttpRequest('my_utime/album/photo/examine/info', params, {method: 'GET'})

// 获取h5最新地址
export const getH5Url = params => utimeHttpRequest('https://pro.kapaisy.com/my/my_account/account/h5/version', params, {method: 'GET'})
// export const getH5Url = () => utimeHttpRequest("https://pro.kapaisy.com/my/my_utime/pl/h5/url", { method: "GET" })

// 根据code 获取微信用户的openid
export const getOpenId = params => utimeHttpRequest('https://pro.kapaisy.com/my/my_account/user/login/wx/openId', params, {method: 'POST'})

// 创建购买照片订单
export const createBuyPhotoOrder = params => utimeHttpRequest('my_utime/pay/photo/create/order', params, {method: 'POST'})

// 相册内购买照片列表
export const buyPhotoList = params => utimeHttpRequest('my_utime/pl/album/buy/photo/list', params, {method: 'POST'})

export const textWxPay = params => utimeHttpRequest('my_utime/pay/photo/query/order/test', params, {method: 'GET'})

// 获取相册已售照片列表
export const sellPhotoList = params => utimeHttpRequest('my_utime/pl/album/sold/photo/list', params, {method: 'POST'})

// 号码识别列表
export const ocrPhotoList = params => utimeHttpRequest('my_utime/orc/search', params, {method: 'POST'})

// 获取打包列表
export const getAlbumPackageList = params => utimeHttpRequest('my_utime/album/download', params, {method: 'GET'})

//相册热门列表
export const hotPhotoList = params => utimeHttpRequest('my_utime/pl/album/photo/hot/list', params, {method: 'POST'})

//根据选择照片生成小程序下载太阳码
export const downloadMiniCode = params => utimeHttpRequest('my_utime/album/invite/download/photo/code', params, {method: 'POST'})

// 选中照片
export const addSelectPhoto = params => utimeHttpRequest('my_utime/album/select/add', params, {method: 'POST'})

// 删除选片
export const deleteSelectPhoto = params => utimeHttpRequest('my_utime/album/select/delete', params, {method: 'POST'})

// 添加日志
export const addAlbumLog = params => utimeHttpRequest('my_utime/data/buried/point/log', params, { method: 'POST' })

// 相册内图片数量
export const getNowAlbumNum = params => utimeHttpRequest('my_utime/pl/album/photo/count', params, {method: 'GET'})

// 根据labelId 批量获取水印列表
export const getWaterForLabel = params => utimeHttpRequest('my_utime/pl/album/watermark/list', params, { method: 'GET' })

// 照片投票
export const vote = params => utimeHttpRequest('my_utime/album/vote/use', params, { method: 'POST' })

// 照片排行榜
export const voteList = params => utimeHttpRequest('my_utime/album/vote/list', params, {method: 'GET'})
